import { a as languages } from "../../core-8vQkh0Rd.js";
import "./csharp.js";
import { t as createT4 } from "../../t4-templating-BDUium7S.js";
//#region src/prism/languages/t4-cs.js
languages.t4 = languages["t4-cs"] = createT4("csharp");
//#endregion

//# sourceMappingURL=t4-cs.js.map